// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1nxsC","active":"Button_active__1tsqp","small":"Button_small__17Zl-","hidden":"Button_hidden__3leUw"};